// extracted by mini-css-extract-plugin
export default {"button":"FetchRoutes_button__eKa2z"};